import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const RosterNewIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                d="M16.832 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.285 0-15-6.716-15-15 0-8.284 6.715-15 15-15zm0 2c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zm0 5a1 1 0 0 1 1 1v6h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1-2 0v-6h-6a1 1 0 0 1 0-2h6V9a1 1 0 0 1 1-1z"
            />
        </svg>
    );
};
